import React, { useEffect, useRef, useState } from "react";
import axios, { AxiosResponse } from "axios";
import { DataTableWithoutButtons } from "components/DataTable/DataTableWithoutButtons";
import { AfDataType } from "utils/TableColumnData";
import handleWheel from "utils/handleOnWheel";
import { ListCommanWay, UpdateCommanWay, CreateCommanWay } from "API/commonApi";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { Button, Img } from "components";
import { useAuthStore } from "store/auth";
import moment from "moment";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";
import Select from "react-select";
import { roles } from "utils/constant";
import { utils, write, writeFile } from "xlsx";
import { saveAs } from "file-saver";
import {
  ArrowDownIcon,
  ArrowUpIcon,
  ArrowsUpDownIcon,
  PencilIcon,
  PencilSquareIcon,
} from "@heroicons/react/24/outline";
import { AfDateRangePicker } from "components/Input/AfDateRangePicker";

const VouchureGen: React.FC<any> = (props) => {
  const ADT = AfDataType;
  const tableRef = useRef(null);

  const [tableData, setTableData] = useState<any>([]);
  const [tableDetails, setTableDetails] = useState<any>([]);
  const [totals, setTotals] = useState<any>([]);

  const [startDate, setStartDate] = useState<any>(moment().startOf("day").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState<any>(moment().endOf("day").format("YYYY-MM-DD"));
  const [query, setQuery] = useState<any>({
    bill_from: {
      $gte: moment().startOf("day"),
      $lte: moment().endOf("day"),
    },
  });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [fetchedData, setFetchedData] = useState([]);
  const [isDataAdded, setIsDataAdded] = useState(false);

  const [selectedAgent, setSelectedAgent] = useState<any[]>([]);
  const [allAgents, setAllAgents] = useState([]);
  const [selectedBillIds, setSelectedBillIds] = useState<any[]>([]);
  const [onlyVerified, setOnlyVerified] = useState(false);
  const [sortStat, setSortStat] = useState<any>({});

  useEffect(() => {
    const userD = (() => { const auth = localStorage.getItem("auth"); return auth ? JSON.parse(auth) : {}; })();
    if (Object.keys(userD).length) {
      setUserDetails(userD.state.user);
      if (userD.state.user.roleName == roles.SUPER_ADMIN) {
        mutateListAgents({ subbranch: undefined });
      } else if (userD.state.user.roleName == roles.SUBBRANCH_ADMIN) {
        mutateListAgents({ subbranch: userD.state.user?.subbranch });
      } else {
        mutateListAgents({ subbranch: undefined });
      }
    }
  }, []);
  const { mutate: mutateListAgents }: any = useMutation(
    (qry: any) => ListCommanWay("/admin/user/list", { 
      subbranch: qry?.subbranch,
      isActive: true,
      isThirdParty: false
    }, { paginate: 100000 }),
    {
      onSuccess: (data: any) => {
        if (data.status == "SUCCESS") {
          setAllAgents([...data.data.data]);
        }
      },
      onError: (data: any) => {},
    }
  );

  const handleSubmit = async () => {
    console.log("Ad");
    setIsDataAdded(!isDataAdded);
    setQuery({
      bill_from: {
        $gte: startDate ? startDate : moment().startOf("day").subtract(7, "days"),
        $lte: endDate ? moment(endDate).endOf("day") : moment().endOf("day"),
      },
      bill_id: { $ne: null },
      addedBy: userDetails.roleName == "DELIVERY" ? userDetails.id : selectedAgent.length > 0 ? (selectedAgent.length === 1 ? selectedAgent[0].id : { $in: selectedAgent.map((a) => a.id) }) : undefined,
      pay_status: onlyVerified ? "VERIFIED" : undefined,
    });
  };

  const { isFetching, isLoading, refetch } = useQuery(
    ["admin_km_vouchures_list"],
    () =>
      ListCommanWay("/admin/km_vouchure/list", query, {
        include: [],
        paginate: 10000,
        doSum: true,
      }),
    {
      keepPreviousData: true,
      enabled: false,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          console.log("data.data", data.data);
          setTableData(data.data.data);
          setTableDetails([]);
          let _totals = {
            km: 0,
            amount: 0,
          };
          data.data.data.forEach((item) => {
            _totals.km += Number(item.total_km);
            _totals.amount += Number(item.start_end_note);
          });
          setTotals(_totals);
        } else {
          setTableData([]);
        }
      },
      onError: (data) => {
        setTableData([]);
      },
    }
  );

  const { mutate: mutateVouchureDetail }: any = useMutation(
    (qry: any) =>
      ListCommanWay(
        "/admin/km_vouchure/list",
        {
          bill_id: qry,
        },
        { paginate: 100000 }
      ),
    {
      onSuccess: (data: any) => {
        if (data.status == "SUCCESS") {
          setTableDetails(data.data.data);
        }
      },
      onError: (data: any) => {},
    }
  );

  useEffect(() => {
    refetch();
    if (query.addedBy) {
    }
  }, [query]);

  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const userD = (() => { const auth = localStorage.getItem("auth"); return auth ? JSON.parse(auth) : {}; })();
  const [userDetails, setUserDetails] = useState<any>(userD?.state?.user || {});
  const { paymentPublicKey } = useAuthStore();

  const encryptWithRSA = async (data: object): Promise<string | false> => {
    if (!paymentPublicKey) return false;
    try {
      let pemBody = paymentPublicKey
        .replace(/-----BEGIN (RSA )?PUBLIC KEY-----/g, "")
        .replace(/-----END (RSA )?PUBLIC KEY-----/g, "")
        .replace(/\\n/g, "")
        .replace(/\s/g, "");
      const binaryDer = Uint8Array.from(atob(pemBody), (c) => c.charCodeAt(0));
      const cryptoKey = await crypto.subtle.importKey(
        "spki",
        binaryDer.buffer,
        { name: "RSA-OAEP", hash: "SHA-256" },
        false,
        ["encrypt"],
      );
      const encoded = new TextEncoder().encode(JSON.stringify(data));
      const encrypted = await crypto.subtle.encrypt({ name: "RSA-OAEP" }, cryptoKey, encoded);
      const bytes = new Uint8Array(encrypted);
      let binary = "";
      for (let i = 0; i < bytes.length; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return btoa(binary);
    } catch (e) {
      console.error("RSA-OAEP encryption failed:", e);
      return false;
    }
  };

  const handleBulkPayment = async () => {
    if (!paymentPublicKey) {
      UseToast("Payment key not available. Please re-login.", "error");
      return;
    }
    if (selectedBillIds.length === 0) {
      UseToast("Please select vouchers first.", "error");
      return;
    }

    const encryptedPayload = await encryptWithRSA({ paymentType: "KM_VOUCHER" });
    if (!encryptedPayload) {
      UseToast("Encryption failed. Please re-login.", "error");
      return;
    }

    try {
      const otpRes: any = await CreateCommanWay({
        url: "/admin/payment/request-otp",
        data: { ids: selectedBillIds, encryptedPayload },
      });

      if (otpRes?.status !== "SUCCESS") {
        UseToast(otpRes?.message || "Failed to request OTP", "error");
        return;
      }

      const requestId = otpRes?.data?.requestId;

      const { value: otp } = await Swal.fire({
        title: "Enter OTP",
        input: "text",
        inputPlaceholder: "Enter 6-digit OTP",
        showCancelButton: true,
        confirmButtonText: "Release Payment",
        inputValidator: (value) => {
          if (!value) return "Please enter OTP";
          if (value.length !== 6) return "OTP must be 6 digits";
        },
      });

      if (!otp) return;

      const encryptedRelease = await encryptWithRSA({ requestId, otp });
      if (!encryptedRelease) {
        UseToast("Encryption failed.", "error");
        return;
      }

      const releaseRes: any = await CreateCommanWay({
        url: "/admin/payment/release",
        data: { payload: encryptedRelease },
      });

      if (releaseRes?.status === "SUCCESS") {
        UseToast("Payment released successfully!", "success");
        setSelectedBillIds([]);
        refetch();
      } else {
        UseToast(releaseRes?.message || "Payment release failed", "error");
      }
    } catch (err: any) {
      UseToast(typeof err === "string" ? err : err?.message || "Something went wrong", "error");
    }
  };

  const {
    mutate: generateKmVoucher,
    isLoading: isloading,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation(
    (destination = "") =>
      ListCommanWay(
        "/admin/km_vouchure/generate",
        {
          bill_from: startDate ? startDate : moment().startOf("day").subtract(7, "days"),
          bill_to: endDate ? moment(endDate).endOf("day") : moment().endOf("day"),
          addedBy: selectedAgent.length > 0 ? (selectedAgent.length === 1 ? selectedAgent[0].id : { $in: selectedAgent.map((a) => a.id) }) : undefined,
        },
        {}
      ),
    {
      onSuccess: (data: any) => {
        console.log(data, data.status == "SUCCESS");
        if (data.status == "SUCCESS") {
          UseToast("Data Added Successfully", "success");
        } else {
          UseToast(data.message, "error");
        }
      },
      onError: (data: any) => {
        typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      },
    }
  );

  const {
    mutate: deleteKmVoucher,
    isLoading: isDeleteVoucherloading,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation((bill_id) => ListCommanWay("/admin/km_vouchure/delete", { bill_id }, {}), {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        refetch();
        UseToast("Data Delted Successfully", "success");
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });

  const {
    mutate: updatePayInfo,
    isLoading: isloadingPayInfo,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation((data) => UpdateCommanWay(data), {
    onSuccess: (data: any) => {
      console.log(data, data.status == "SUCCESS");
      if (data.status == "SUCCESS") {
        refetch();
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });
  const onPayStatusChange = (id: any, status) => {
    Swal.fire({
      title: "Are you sure!",
      text: "Changing Status to : " + status,
      icon: "info",
      confirmButtonText: "Yes",
      showCancelButton: true,
      html: '<input id="transactionNo" class="swal2-input" placeholder="Transaction No">',
    }).then((x) => {
      if (x.isConfirmed) {
        let updateData: any = {
          transaction_no: (document.getElementById("transactionNo") as any).value,
          pay_status: status,
        };

        updatePayInfo({
          url: "/admin/km_vouchure/updatePayInfo/" + id,
          data: updateData,
        });
      }
    });
  };

  const onVerifyStatusChange = (id: any, amount?: any) => {
    Swal.fire({
      title: "Verify Voucher",
      text: "Enter Payable Amount",
      icon: "info",
      confirmButtonText: "Verify",
      showCancelButton: true,
      html: `<input id="payAmountInput" class="swal2-input" placeholder="Payable Amount" type="number" value="${amount || ""}">`,
    }).then((x) => {
      if (x.isConfirmed) {
        const payAmount = (document.getElementById("payAmountInput") as any).value;
        if (!payAmount) {
          UseToast("Please enter payable amount", "error");
          return;
        }
        updatePayInfo({
          url: "/admin/km_vouchure/updatePayInfo/" + id,
          data: { payAmount: Number(payAmount), pay_status: "VERIFIED" },
        });
      }
    });
  };

  const onTraIdChange = (id: any) => {
    Swal.fire({
      title: "Enter New Transaction Number",
      icon: "info",
      confirmButtonText: "Yes",
      showCancelButton: true,
      html: '<input id="transactionNo" class="swal2-input" placeholder="Transaction No">',
    }).then((x) => {
      if (x.isConfirmed) {
        let updateData: any = {
          transaction_no: (document.getElementById("transactionNo") as any).value,
        };
        updatePayInfo({
          url: "/admin/km_vouchure/updatePayInfo/" + id,
          data: updateData,
        });
      }
    });
  };

  const exportToExcel = () => {
    const table = tableRef.current;

    const tableClone = table.cloneNode(true);

    const tfoot = tableClone.getElementsByTagName("tfoot");
    if (tfoot.length > 0) {
      tfoot[0].remove();
    }

    const ws = utils.table_to_sheet(tableClone);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");

    Object.keys(ws).forEach((key) => {
      if (key.startsWith("!")) return;

      let cell = ws[key];
      if (cell && cell.h && typeof cell.h === "string") {
        cell.h = null;
      }
      if (cell && cell.l) {
        delete cell.l;
      }
    });

    const wbout = write(wb, { bookType: "xlsx", type: "array" });

    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, "Vouchure Report.xlsx");
  };

  const GET_SORT_ICON = (key: string) => {
    switch (sortStat[key]) {
      case "asc":
        return <ArrowDownIcon className="h-4 inline-block cursor-pointer" onClick={() => handleSort(key)} />;
      case "desc":
        return <ArrowUpIcon className="h-4 inline-block cursor-pointer" onClick={() => handleSort(key)} />;
      default:
        return <ArrowsUpDownIcon className="h-4 inline-block cursor-pointer" onClick={() => handleSort(key)} />;
    }
  };

  const handleSort = (key: string) => {
    const order = sortStat[key] === "asc" ? "desc" : "asc";
    const sortedData = [...tableData].sort((a, b) => {
      const valueA = Number(a[key] ?? 0);
      const valueB = Number(b[key] ?? 0);

      if (Number.isNaN(valueA) || Number.isNaN(valueB)) {
        const textA = String(a[key] ?? "");
        const textB = String(b[key] ?? "");
        if (textA < textB) return order === "asc" ? -1 : 1;
        if (textA > textB) return order === "asc" ? 1 : -1;
        return 0;
      }

      return order === "asc" ? valueA - valueB : valueB - valueA;
    });

    setSortStat((prev: any) => ({ ...prev, [key]: order }));
    setTableData(sortedData);
  };

  return (
    <>
      <h1 className="text-center mb-4 mt-3 text-lg font-semibold ">
        {userDetails.roleName == "DELIVERY" ? "Travel" : "Generate KM. "} Vouchure
      </h1>
      <div className="flex items-end flex-col gap-4 px-4  border-[1px] p-4 m-4 rounded-md">
        <div className="flex gap-1 items-center flex-wrap border p-2 rounded-xl bg-gray-200 border-blue-600 w-full">
          {[1, 2, 3, 5, 9].includes(userDetails.role_name) && (
            <div className={`inline-flex items-center gap-2 mr-6`}>
              <label className="text-sm font-semibold text-gray-900 whitespace-nowrap">Select Employee</label>
              <Select
                className={`bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block min-w-52 `}
                options={allAgents}
                isMulti
                onChange={(e: any) => {
                  setSelectedAgent(e || []);
                }}
                value={selectedAgent}
                getOptionValue={(e) => {
                  return e.id + "";
                }}
                getOptionLabel={(e) => {
                  return e.name;
                }}
                isClearable={true}
              />
            </div>
          )}

          <AfDateRangePicker setStartDate={setStartDate} setEndDate={setEndDate} label="Start - End Date" />

          <label className="ml-2 inline-flex items-center gap-1.5 cursor-pointer select-none">
            <input
              type="checkbox"
              className="w-4 h-4 rounded border-gray-300 text-purple-600 focus:ring-purple-500"
              checked={onlyVerified}
              onChange={(e) => setOnlyVerified(e.target.checked)}
            />
            <span className="text-sm font-semibold text-purple-700 whitespace-nowrap">Only Verified</span>
          </label>

          <button
            type="button"
            onClick={handleSubmit}
            className="ml-2 rounded-md px-4 py-2 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
          >
            Search
          </button>

          {userDetails.roleName != "DELIVERY" && (
            <button
              type="button"
              onClick={generateKmVoucher}
              className="ml-2 rounded-md px-4 py-2 text-sm font-medium text-white bg-blue-600 border-4 border-red-600 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
            >
              Generate
            </button>
          )}
          {userDetails.role_name == 1 && paymentPublicKey && selectedBillIds.length > 0 && (
            <button
              type="button"
              onClick={handleBulkPayment}
              className="ml-2 rounded-md px-4 py-2 text-sm font-medium text-white bg-amber-500 border border-amber-600 hover:bg-amber-600 focus:z-10 focus:ring-2 focus:ring-amber-700"
            >
              Bulk Payment ({selectedBillIds.length})
            </button>
          )}
        </div>
      </div>
      <div>
        <table className="w-full table- mb-4 text-sm">
          <thead>
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th>{totals.km / 1000}</th>
              <th>{totals.amount}</th>
            </tr>
            <tr>
              {userDetails.role_name == 1 && paymentPublicKey && (
                <th className="border border-slate-200 px-2">
                  <input
                    type="checkbox"
                    className="w-4 h-4"
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedBillIds(tableData.filter((r) => r.pay_status !== "PAID").map((r) => r.bill_id));
                      } else {
                        setSelectedBillIds([]);
                      }
                    }}
                    checked={selectedBillIds.length > 0 && selectedBillIds.length === tableData.filter((r) => r.pay_status !== "PAID").length}
                  />
                </th>
              )}
              <th className="border border-slate-200">Action</th>
              <th className="border border-slate-200">Name</th>

              <th className="border border-slate-200">From Date</th>
              <th className="border border-slate-200">To Date</th>
              <th className="border border-slate-200">Vouchure Date</th>

              <th className="border border-slate-200">Vouchure Id</th>
              <th className="border border-slate-200">Total KM {GET_SORT_ICON("total_km")}</th>
              <th className="border border-slate-200">Amount</th>
              <th className="border border-slate-200">Payable Amt {GET_SORT_ICON("payAmount")}</th>
              <th className="border border-slate-200">Transaction No</th>
              <th className="border border-slate-200">Pay date</th>
              {userDetails.roleName != "DELIVERY" && <th className="border border-slate-200">Pay</th>}
            </tr>
          </thead>
          <tbody>
            {tableData.map((r) => {
              return (
                <tr className={r.pay_status == "PAID" ? "bg-green-400" : r.pay_status == "VERIFIED" ? "bg-purple-300" : r.transaction_no == "PROCESS" ? "bg-orange-300" : ""}>
                  {userDetails.role_name == 1 && paymentPublicKey && (
                    <td className="border border-slate-200 px-2 text-center">
                      {r.pay_status !== "PAID" && (
                        <input
                          type="checkbox"
                          className="w-4 h-4"
                          checked={selectedBillIds.includes(r.bill_id)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedBillIds([...selectedBillIds, r.bill_id]);
                            } else {
                              setSelectedBillIds(selectedBillIds.filter((id) => id !== r.bill_id));
                            }
                          }}
                        />
                      )}
                    </td>
                  )}
                  <td className="text-center">
                    <button
                      onClick={() => {
                        mutateVouchureDetail(r.bill_id);
                      }}
                      className="rounded-md px-4 py-1 text-sm font-medium text-white bg-orange-400 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 "
                    >
                      Load
                    </button>
                    {userDetails.roleName != "DELIVERY" && !["KIRANG", "sarvanaa"].includes(userDetails.username) && (
                      <button
                        onClick={() => {
                          Swal.fire({
                            title: "Are you sure?",
                            icon: "error",
                            confirmButtonText: "Yes",
                            showCancelButton: true,
                          }).then((x) => {
                            if (x.isConfirmed) {
                              deleteKmVoucher(r.bill_id);
                            }
                          });
                          //
                        }}
                        className="ml-2 rounded-md px-4 py-1 text-sm font-medium text-white bg-red-600 border"
                      >
                        Delete
                      </button>
                    )}
                    {userDetails.roleName != "DELIVERY" && !["KIRANG", "sarvanaa"].includes(userDetails.username) && (
                      <Button
                        className="ml-2 rounded-md px-4 pb-1 text-sm font-medium text-white bg-blue-600 border"
                        onClick={() => {
                          onTraIdChange(r.bill_id);
                        }}
                      >
                        <PencilSquareIcon className="h-4 inline-block" />
                      </Button>
                    )}
                  </td>
                  <td className="border border-slate-200 px-2 text-center">{r.name}</td>
                  <td className="border border-slate-200 px-2 text-center">{moment(r.bill_from).format("DD-MM-YYYY")}</td>
                  <td className="border border-slate-200 px-2 text-center">{moment(r.bill_to).format("DD-MM-YYYY")}</td>
                  <td className="border border-slate-200 px-2 text-center">{moment(r.bill_date).format("DD-MM-YYYY")}</td>

                  <td className="border border-slate-200 px-2 text-center">{r.bill_id}</td>
                  <td className="border border-slate-200 px-2 text-center">{r.total_km / 1000}</td>
                  <td className="border border-slate-200 px-2 text-center">{r.start_end_note}</td>
                  <td className="border border-slate-200 px-2 text-center">{r.payAmount}</td>
                  <td className="border border-slate-200 px-2 text-center">{r.transaction_no}</td>
                  <td className="border border-slate-200 px-2 text-center">{r.pay_date && moment(r.pay_date).format("DD-MM-YYYY")}</td>
                  {userDetails.roleName != "DELIVERY" && (
                    <td className="border border-slate-200 px-2 text-center">
                      {r.pay_status != "PAID" && (
                        <button
                          onClick={() => {
                            onPayStatusChange(r.bill_id, "PAID");
                          }}
                          className="rounded-md px-4 py-1 text-sm font-medium text-white bg-green-600 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 "
                        >
                          Pay
                        </button>
                      )}
                      {r.pay_status != "PAID" && r.pay_status != "VERIFIED" && (
                        <button
                          onClick={() => {
                            onVerifyStatusChange(r.bill_id, r.start_end_note);
                          }}
                          className="ml-2 rounded-md px-4 py-1 text-sm font-medium text-white bg-purple-600 border border-gray-200 hover:bg-purple-400 hover:text-white "
                        >
                          Verify
                        </button>
                      )}
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="px-4">
        <button onClick={exportToExcel} className=" bg-blue-600 text-white px-4 py-1 rounded-md">
          Excel Export
        </button>
        <table className="w-full table- mb-4 text-sm" id="myTable" ref={tableRef}>
          <thead>
            <tr>
              <th className="border border-slate-200">Trip id</th>
              <th className="border border-slate-200">Action</th>
              <th className="border border-slate-200">PRN</th>
              <th className="border border-slate-200">Awb</th>
              <th className="border border-slate-200 w-28">Started At</th>
              <th className="border border-slate-200">Km</th>
              <th className="border border-slate-200">Total</th>
              <th className="border border-slate-200">location</th>
              <th className="border border-slate-200">lat,long</th>
            </tr>
          </thead>
          <tbody>
            {tableDetails.map((r) => {
              return (
                <tr className={`${r.remark == "START" ? "border-t-4 border-blue-600" : ""}`}>
                  <td className="border border-slate-200 px-4">{r.vouchure_id}</td>
                  <td className="border border-slate-200 px-4">{r.remark}</td>

                  <td className="border border-slate-200 px-4">
                    {r.pickup_code?.split(",").map((a) => {
                      return (
                        <>
                          <a>{a}</a>,
                          <br />
                        </>
                      );
                    })}
                  </td>

                  <td className="border border-slate-200 px-4">
                    {r.awb_nos?.split(",").map((a) => {
                      return (
                        <>
                          <a href={`/pod/tracking?awb=${a}`} target="_blank">
                            {a}
                          </a>
                          ,
                          <br />
                        </>
                      );
                    })}
                  </td>

                  <td className="border border-slate-200 px-4">{moment(r.createdAt, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY HH:mm")}</td>

                  <td className="border border-slate-200 px-4 whitespace-nowrap text-right">{(r.km / 1000).toFixed(2) + " km"}</td>
                  <td className="border border-slate-200 px-4 whitespace-nowrap text-right text-blue-600 font-semibold">
                    {r.remark == "STOP" && (r.total / 1000).toFixed(2) + " km"}
                  </td>
                  <td className="border border-slate-200 px-4">{r.location}</td>
                  <td className="border border-slate-200 px-4">
                    {r.lat},{r.long}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default VouchureGen;
